export const SETTINGS = {
  cstore: {
    regular: {
      walls: 0,
      air: 0,
      pegAir: 5,
      buttonWidth: 10,
      bottom: 17,
      top: 55,
      alignWalls: 3,
      sameHeight: true,
      widthCoef: 1,
      priceTemplate: 'cstore',
      deep: 3,
      styleClass: 'regularTypeTarget'
    },
    displayFridge: {
      walls: 2,
      air: 0,
      buttonWidth: 10,
      alignWalls: 4,
      emptyWalls: 0,
      bottom: 5,
      sameHeight: true,
      fridge: true,
      discrete: true,
      displayWidth: 430,
      widthCoef: 1,
      priceTemplate: 'cstore',
      deep: 3,
      top: 25,
      styleClass: 'fridgeTypeTarget',
      bottomImage: './svg/bottom.svg',
      bottomLeftImage: './svg/bottom-left.svg',
      bottomRightImage: './svg/bottom-rigth.svg'
    },
    counterFridge: {
      walls: 0,
      emptyWalls: 25,
      air: 0,
      pegAir: 0,
      buttonWidth: 5,
      bottom: 15,
      sameHeight: true,
      widthCoef: 1,
      priceTemplate: 'cstore',
      top: 90,
      styleClass: 'counterFridge',
      deep: 3,
      bottomAdditionalHeight: 0,
      autoStacking: true,
      bottomMargin: 25
    }
  },
  samsclub: {
    pallet: {
      walls: 39,
      emptyWalls: 2,
      air: 5,
      pegAir: 5,
      buttonWidth: 14,
      bottom: 35,
      widthCoef: 1,
      priceTemplate: 'samsclub',
      double: true,
      top: 35,
      topFirst: 150,
      topBottom: 35,
      deep: 3,
      styleClass: 'samsclub',
      holders: true,
      bottomAdditionalHeight: 10,
      autoStacking: true
    },
    counterFridge: {
      walls: 2,
      emptyWalls: 25,
      air: 0,
      pegAir: 0,
      buttonWidth: 5,
      bottom: 15,
      sameHeight: true,
      widthCoef: 1,
      priceTemplate: 'samsclub',
      top: 90,
      styleClass: 'counterFridge',
      deep: 3,
      bottomAdditionalHeight: 0,
      autoStacking: true,
      bottomMargin: 25
    }
  },
  publix: {
    regular: {
      walls: 7,
      air: 5,
      pegAir: 5,
      buttonWidth: 10,
      bottom: 17,
      alignWalls: 3,
      sameHeight: true,
      widthCoef: 1,
      priceTemplate: 'publix',
      deep: 3,
      top: 55,
      styleClass: 'publix'
    },
    counterFridge: {
      walls: 2,
      emptyWalls: 25,
      air: 0,
      pegAir: 0,
      buttonWidth: 5,
      bottom: 15,
      sameHeight: true,
      widthCoef: 1,
      priceTemplate: 'publix',
      top: 90,
      styleClass: 'counterFridge',
      deep: 3,
      bottomAdditionalHeight: 0,
      autoStacking: true,
      bottomMargin: 25
    }
  },
  cvs: {
    regular: {
      walls: 7,
      air: 5,
      pegAir: 5,
      buttonWidth: 10,
      bottom: 17,
      alignWalls: 3,
      sameHeight: true,
      widthCoef: 1,
      priceTemplate: 'cvs',
      deep: 3,
      top: 55,
      styleClass: 'cvs'
    }
  },
  family: {
    regular: {
      walls: 7,
      air: 5,
      pegAir: 5,
      buttonWidth: 10,
      bottom: 17,
      alignWalls: 3,
      sameHeight: true,
      widthCoef: 1,
      priceTemplate: 'family',
      deep: 3,
      top: 55,
      styleClass: 'family'
    }
  },
  dollar: {
    regular: {
      walls: 7,
      air: 5,
      pegAir: 5,
      buttonWidth: 10,
      bottom: 17,
      alignWalls: 3,
      sameHeight: true,
      widthCoef: 1,
      priceTemplate: 'dollar',
      deep: 3,
      top: 55,
      styleClass: 'dollar'
    }
  },
  walgreens: {
    regular: {
      walls: 7,
      air: 5,
      pegAir: 5,
      buttonWidth: 10,
      bottom: 19,
      alignWalls: 3,
      sameHeight: true,
      widthCoef: 1,
      priceTemplate: 'walgreens',
      deep: 3,
      top: 55,
      styleClass: 'walgreens'
    }
  },
  amazon: {
    regular: {
      walls: 7,
      air: 5,
      pegAir: 5,
      buttonWidth: 10,
      bottom: 17,
      alignWalls: 3,
      sameHeight: true,
      widthCoef: 1,
      priceTemplate: 'amazon',
      deep: 3,
      top: 55,
      styleClass: 'amazon'
    }
  },
  target: {
    regular: {
      walls: 7,
      air: 5,
      pegAir: 5,
      buttonWidth: 10,
      bottom: 17,
      alignWalls: 3,
      sameHeight: true,
      widthCoef: 1,
      priceTemplate: 'target',
      deep: 3,
      top: 55,
      styleClass: 'regularTypeTarget'
    },
    displayFridge: {
      walls: 2,
      air: 0,
      buttonWidth: 10,
      alignWalls: 4,
      emptyWalls: 0,
      bottom: 5,
      sameHeight: true,
      fridge: true,
      discrete: true,
      displayWidth: 430,
      widthCoef: 1,
      priceTemplate: 'target',
      deep: 3,
      top: 25,
      styleClass: 'fridgeTypeTarget',
      bottomImage: './svg/bottom.svg',
      bottomLeftImage: './svg/bottom-left.svg',
      bottomRightImage: './svg/bottom-rigth.svg'
    },
    airCurtainFridge: {
      walls: 20,
      air: 1,
      pegAir: 1,
      buttonWidth: 10,
      displayWidth: 430,
      alignWalls: 17,
      bottom: 16,
      fridge: true,
      sameHeight: true,
      widthCoef: 1,
      priceTemplate: 'target',
      deep: 3,
      lastDeep: 5,
      top: 25,
      perspective: 1.15,
      styleClass: 'airCurtain'
    },
    counterFridge: {
      walls: 2,
      emptyWalls: 25,
      air: 0,
      pegAir: 0,
      buttonWidth: 10,
      bottom: 15,
      sameHeight: true,
      widthCoef: 1,
      priceTemplate: 'target',
      top: 90,
      styleClass: 'counterFridge',
      deep: 3,
      bottomAdditionalHeight: 0,
      autoStacking: true,
      bottomMargin: 45
    }
  },
  walmart: {
    regular: {
      walls: 7,
      air: 5,
      pegAir: 5,
      buttonWidth: 10,
      bottom: 17,
      alignWalls: 3,
      sameHeight: true,
      widthCoef: 1,
      priceTemplate: 'walmart',
      deep: 3,
      top: 55,
      styleClass: 'regularTypeTarget'
    },
    displayFridge: {
      walls: 2,
      air: 0,
      buttonWidth: 10,
      alignWalls: 4,
      emptyWalls: 15,
      bottom: 5,
      sameHeight: true,
      fridge: true,
      discrete: true,
      displayWidth: 430,
      widthCoef: 1,
      priceTemplate: 'walmart',
      deep: 3,
      top: 25,
      styleClass: 'fridgeTypeTarget',
      bottomImage: './svg/bottom.svg',
      bottomLeftImage: './svg/bottom-left.svg',
      bottomRightImage: './svg/bottom-rigth.svg'
    },
    airCurtainFridge: {
      walls: 20,
      air: 1,
      pegAir: 1,
      buttonWidth: 10,
      displayWidth: 430,
      alignWalls: 17,
      bottom: 16,
      fridge: true,
      sameHeight: true,
      widthCoef: 1,
      priceTemplate: 'walmart',
      deep: 3,
      lastDeep: 5,
      top: 25,
      perspective: 1.15,
      styleClass: 'airCurtain'
    },
    counterFridge: {
      walls: 2,
      emptyWalls: 25,
      air: 0,
      pegAir: 0,
      buttonWidth: 10,
      bottom: 15,
      sameHeight: true,
      widthCoef: 1,
      priceTemplate: 'walmart',
      top: 90,
      styleClass: 'counterFridge',
      deep: 3,
      bottomAdditionalHeight: 0,
      autoStacking: true,
      bottomMargin: 45
    }
  },
  costco: {
    pallet: {
      walls: 39,
      emptyWalls: 2,
      air: 5,
      pegAir: 5,
      buttonWidth: 14,
      bottom: 35,
      widthCoef: 1,
      priceTemplate: 'costco',
      double: true,
      top: 35,
      topFirst: 150,
      topBottom: 35,
      deep: 3,
      styleClass: 'costco',
      holders: true,
      dots: true,
      bottomAdditionalHeight: 10,
      autoStacking: true
    },
    counterFridge: {
      walls: 2,
      emptyWalls: 25,
      air: 0,
      pegAir: 0,
      buttonWidth: 5,
      bottom: 15,
      sameHeight: true,
      widthCoef: 1,
      priceTemplate: 'costco',
      top: 90,
      styleClass: 'counterFridge',
      deep: 3,
      bottomAdditionalHeight: 0,
      autoStacking: true,
      bottomMargin: 25
    }
  },
  lowes: {
    regular: {
      walls: 40,
      emptyWalls: 30,
      air: 5,
      pegAir: 5,
      buttonWidth: 45,
      bottom: 35,
      widthCoef: 1,
      alignWalls: 4,
      priceTemplate: 'lowes',
      deep: 3,
      top: 37,
      styleClass: 'lowes',
      holders: true,
      dots: true
    }
  },
  loblaws: {
    regular: {
      walls: 40,
      emptyWalls: 30,
      air: 5,
      pegAir: 5,
      buttonWidth: 45,
      bottom: 35,
      widthCoef: 1,
      alignWalls: 4,
      priceTemplate: 'loblaws',
      deep: 3,
      top: 37,
      styleClass: 'loblaws',
      dots: true
    }
  },
  homedepot: {
    regular: {
      walls: 40,
      emptyWalls: 30,
      air: 5,
      pegAir: 5,
      buttonWidth: 45,
      bottom: 35,
      widthCoef: 1,
      alignWalls: 4,
      priceTemplate: 'homedepot',
      deep: 3,
      top: 37,
      styleClass: 'homedepot',
      holders: true,
      dots: true
    }
  },
  ecommerce: {
    regular: {}
  }
}
